import { ENDPOINTS } from '@/lib/consts'
import DeviceIdentity from './device-identity'

export default class IOSIdentity extends DeviceIdentity {
  registerToken ({ businessId, token }: { businessId: string | number; token: string | Record<string, unknown> }): Promise<unknown> {
    return this.apiCall({
      method: 'PUT',
      url: ENDPOINTS.IOS_TOKEN,
      urlParams: {
        businessId,
        token,
      },
    }).then(() => {
      this.logger.log('Token registered', { businessId, token })
    }).catch(error => {
      this.logger.error(error)
    })
  }

  clearToken ({ businessId, token }: { businessId: string | number; token: string | Record<string, unknown> }): Promise<unknown> {
    return this.apiCall({
      method: 'DELETE',
      url: ENDPOINTS.IOS_TOKEN,
      urlParams: {
        businessId,
        token,
      },
    }).then(() => {
      this.logger.log('Token cleared', { businessId, token })
    }).catch(error => {
      this.logger.error(error)
    })
  }
}
